// =========================================================================
// HelpyDoc · Aviso de "solo visualización" (ADR-018, 13-sep-2026)
//
// "se debe advertir que el acceso de demostracion se puede ver pero no se
// puede participar si no tiene aprovacion clinica" — el director, sesión del
// 13-sep-2026. El gate real (qué se puede o no comprar/hacer) ya lo aplica el
// backend en /commerce/checkout; esto es solo el aviso explícito que ADR-018
// pedía y que hasta hoy no existía en ninguna pantalla.
// =========================================================================
import { useEffect, useState } from 'react';
import { ICONOS_ESTADO } from '@/config/iconografia';
import { getDataMode } from '@/config/data-mode';
import { ApiClient } from '@/services/api-client';

export function AvisoSoloVisualizacion() {
  const [mostrar, setMostrar] = useState(false);

  useEffect(() => {
    // Modo mock: no hay backend real que consultar, y no es a quien va dirigido el aviso.
    if (getDataMode() !== 'api') return;
    let cancelado = false;
    ApiClient.getEligibilidadPropia()
      .then(({ elegible }) => {
        if (!cancelado) setMostrar(!elegible);
      })
      .catch(() => {
        // Sin confirmación no se afirma nada: mostrar un aviso que no se pudo
        // verificar sería peor que no mostrar ninguno. El gate real de
        // participación sigue aplicándose en el servidor pase lo que pase aquí.
      });
    return () => {
      cancelado = true;
    };
  }, []);

  if (!mostrar) return null;

  const Icono = ICONOS_ESTADO.advertencia;

  return (
    <div
      role="status"
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 8,
        padding: '10px 16px',
        background: '#FEF3C7',
        color: '#92400E',
        fontSize: 13,
        fontWeight: 600,
        fontFamily: "'Hanken Grotesk', ui-sans-serif, sans-serif",
        lineHeight: 1.4,
        borderBottom: '1px solid #FDE68A',
      }}
    >
      <Icono size={16} strokeWidth={2.2} style={{ flexShrink: 0, marginTop: 1 }} aria-hidden="true" />
      <span>
        Puedes explorar la app, pero todavía no puedes participar (seguimiento, registro, informes)
        hasta que tu caso sea aprobado clínicamente.
      </span>
    </div>
  );
}
